import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { PromotionContent, PromotionRequestResponse, PromotionSearchCriteria } from '../../models';
import { PromotionAction, PromotionActionTypes } from '../actions/promotion.action';

export interface PromotionState extends EntityState<PromotionContent> {
  isLoading: boolean;
  isCancelSuccess: boolean;
  criteriaObject: PromotionSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  selected: PromotionRequestResponse | null;
}

export const adapter: EntityAdapter<PromotionContent> = createEntityAdapter<PromotionContent>();

export const initialPromotionListState: PromotionState = adapter.getInitialState({
  isLoading: false,
  isCancelSuccess: false,
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: 0,
  totalPages: 0,
  auditLogs: null,
  selected: null
});

export function promotionReducers(state = initialPromotionListState, action: PromotionAction): PromotionState {
  switch (action.type) {
    case PromotionActionTypes.PROMOTION_LIST_REQUEST:
      return {
        ...state,
        isCancelSuccess: false,
        criteriaObject: action.payload
      };
    case PromotionActionTypes.PROMOTION_LIST_RESPONSE:
      return adapter.setAll(action.payload.content, {
        ...state,
        criteriaObject: {
          ...state.criteriaObject,
          page: action.payload.page,
          size: action.payload.size
        },
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages
      });
    case PromotionActionTypes.PROMOTION_GET_BY_ID_RESPONSE:
      return {
        ...state,
        selected: action.payload
      };
    case PromotionActionTypes.PROMOTION_GET_BY_ID_RESET:
      return {
        ...state,
        isCancelSuccess: false,
        selected: null
      };
    case PromotionActionTypes.PROMOTION_CANCEL_SUCCESS:
      return {
        ...state,
        isCancelSuccess: action.payload.isSuccess
      };
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
